module.exports = __webpack_public_path__ + "static/media/CTLI_14-293w.e4374e3c.png";